import type { components } from "@farmacenter/api";
import { useApi } from "../../api/ApiProvider";
import { useOrg } from "../OrgContext";
import { SelectorBuscado } from "./SelectorBuscado";

export type TerceroBuscado = components["schemas"]["ThirdPartySummaryRepresentation"];

export interface SelectorTerceroProps {
  /** Filtra por rol ('supplier', 'customer'…); sin él, busca en todos. */
  rol?: string | undefined;
  label?: string | undefined;
  ocultarEtiqueta?: boolean | undefined;
  onSelect: (tercero: TerceroBuscado | null) => void;
  autoFocus?: boolean | undefined;
  valorInicial?: string | undefined;
}

/** Escribe-y-busca un tercero por NIT o nombre contra `searchThirdParties`. */
export function SelectorTercero({
  rol,
  label,
  ocultarEtiqueta,
  onSelect,
  autoFocus,
  valorInicial,
}: SelectorTerceroProps) {
  const api = useApi();
  const { tenantId } = useOrg();
  return (
    <SelectorBuscado<TerceroBuscado>
      label={label ?? "Proveedor"}
      ocultarEtiqueta={ocultarEtiqueta}
      placeholder="Buscar por NIT o nombre…"
      clave={["buscar-terceros", tenantId, rol ?? "todos"]}
      buscar={(texto) =>
        api.GET("/api/v1/tenants/{tenantId}/third-parties", {
          params: {
            path: { tenantId },
            query: { query: texto, ...(rol ? { role: rol } : {}) },
          },
        })
      }
      getKey={(t) => t.id ?? ""}
      getLabel={(t) => t.legalName ?? t.tradeName ?? "(sin nombre)"}
      getDetalle={(t) => {
        const identificacion = [t.identificationType, t.identificationNumber]
          .filter(Boolean)
          .join(" ");
        const comercial = t.tradeName && t.tradeName !== t.legalName ? ` · ${t.tradeName}` : "";
        return identificacion + comercial;
      }}
      onSelect={onSelect}
      autoFocus={autoFocus}
      valorInicial={valorInicial}
    />
  );
}
